import { render } from "./TextEditorWithAI.vue?vue&type=template&id=575bc62c&scoped=true"
import script from "./TextEditorWithAI.vue?vue&type=script&lang=js"
export * from "./TextEditorWithAI.vue?vue&type=script&lang=js"

import "./TextEditorWithAI.vue?vue&type=style&index=0&id=575bc62c&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575bc62c"]])

export default __exports__